import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};



export type AccountConfigEntity = CoreBaseEntity & {
  __typename?: 'AccountConfigEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accessTokenDuration: Scalars['String'];
  refreshTokenDuration: Scalars['String'];
  accountId: Scalars['String'];
  pwdchangefrequency: Scalars['Float'];
  repeatPwd: Scalars['Float'];
};

export type AccountDebtor = {
  __typename?: 'AccountDebtor';
  accountId?: Maybe<Scalars['String']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  propertyName?: Maybe<Scalars['String']>;
  debtorAccountName?: Maybe<Scalars['String']>;
  contractLotNo?: Maybe<Scalars['String']>;
};

export type AccountDeleteInput = {
  ID: Scalars['String'];
};

export type AccountEntity = CoreBaseEntity & {
  __typename?: 'AccountEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  regNo?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['JSON']>;
  contactPerson?: Maybe<Scalars['JSON']>;
  user?: Maybe<Array<UserAccSoftwareEntity>>;
  newsFeed: Array<NewsFeedEntity>;
  serviceRequests?: Maybe<Array<ServiceRequest>>;
  roles?: Maybe<Array<RoleEntity>>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
  sNumberFormats?: Maybe<Array<SNumberFormat>>;
  subscription: Array<SubscriptionEntity>;
  termsConditions: Array<TermsConditionsEntity>;
  bankAccount: Array<FromBankAccountEntity>;
  accountSettings: Array<SAccountSettings>;
  paymentTransactions?: Maybe<Array<SPaymentTransaction>>;
  currency?: Maybe<CurrencyEntity>;
  gatewayVersion?: Maybe<Scalars['String']>;
};


export type AccountEntityNewsFeedArgs = {
  IsFindLatestPostDate?: Maybe<Scalars['Boolean']>;
};

export type AccountInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  code: Scalars['String'];
  email: Scalars['String'];
  regNo: Scalars['String'];
  contactNo: Scalars['String'];
  address?: Maybe<AddressInput>;
  contactPerson?: Maybe<ContactPersonInput>;
  currencyId?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export type Address = {
  __typename?: 'Address';
  siteName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export type AddressInput = {
  siteName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export enum AddressType {
  Primary = 'PRIMARY',
  Delivery = 'DELIVERY',
  Site = 'SITE'
}

export type AttachmentByRefIdAndRefTableInput = {
  refId: Scalars['String'];
  refTable: Scalars['String'];
  module?: Maybe<Scalars['String']>;
};

export type AttachmentData = {
  __typename?: 'AttachmentData';
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type AttachmentEntity = CoreBaseEntity & {
  __typename?: 'AttachmentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  refTable?: Maybe<Scalars['String']>;
  refType?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['String']>;
  mediaType: Scalars['String'];
  resourceUrl?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  bucketFileName?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  commonStatus: CommonStatus;
  fileSize: Scalars['Float'];
  requestActivity: RequestActivity;
  requestFollowUp: RequestFollowUp;
  requestEstimation: RequestEstimation;
  newsFeed?: Maybe<NewsFeedEntity>;
  account: AccountEntity;
};

export type AttachmentModel = {
  file?: Maybe<Scalars['Upload']>;
};

export type AuditEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
};

export type BaseInput = {
  ID?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export type BusinessInsightOutput = {
  __typename?: 'BusinessInsightOutput';
  openCase?: Maybe<Scalars['Float']>;
  resolvedCase?: Maybe<Scalars['Float']>;
  inProgressCase?: Maybe<Scalars['Float']>;
  closedCase?: Maybe<Scalars['Float']>;
  monthText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CancelServiceRequestModel = {
  requestId: Scalars['String'];
  reason: Scalars['String'];
};

export type CityEntity = CoreBaseEntity & {
  __typename?: 'CityEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  stateId: Scalars['String'];
  commonStatus: CommonStatus;
  state: StateEntity;
  postcode: Array<PostcodeEntity>;
};

export type CityInput = {
  name?: Maybe<Scalars['String']>;
  stateID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type CloudStorageOutput = {
  __typename?: 'CloudStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};

export enum CommonStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Block = 'BLOCK'
}

export type CompanyData = {
  __typename?: 'CompanyData';
  name?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Float']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  name?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type ContactPersonInput = {
  name?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type CoreBaseEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type CountryEntity = CoreBaseEntity & {
  __typename?: 'CountryEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  commonStatus: CommonStatus;
  state: Array<StateEntity>;
};

export type CountryInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type CreateAuditInput = {
  createdBy?: Maybe<Scalars['String']>;
};

export type CurrencyEntity = CoreBaseEntity & {
  __typename?: 'CurrencyEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  commonStatus: CommonStatus;
  account: Array<AccountEntity>;
};

export type CurrencyExchangeEntity = {
  __typename?: 'CurrencyExchangeEntity';
  fromCurrencyId: Scalars['String'];
  toCurrencyId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  fromAmt: Scalars['Float'];
  toAmt: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  commonStatus: CommonStatus;
};


export type DownloadLogEntity = CoreBaseEntity & {
  __typename?: 'DownloadLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  attachmentId?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileSize: Scalars['Float'];
  modulePath?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
};

export type EditTenantUserAndRoleInput = {
  name: Scalars['String'];
  contactNo?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  email: Scalars['String'];
  roleIds?: Maybe<Array<Scalars['String']>>;
};

export type EmailBlastArgs = {
  __typename?: 'EmailBlastArgs';
  senderName: Scalars['String'];
  senderEmail: Scalars['String'];
  recipients: Array<Scalars['String']>;
  subject: Scalars['String'];
  message: Scalars['String'];
  isMultiple: Scalars['Boolean'];
  ccEmail?: Maybe<Array<Scalars['String']>>;
  bccEmail?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<Scalars['String']>>;
  attachments?: Maybe<Array<AttachmentData>>;
  replyTo?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Float']>;
};

export type EmailBlastAttachment = {
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type EmailBlastLogEntity = CoreBaseEntity & {
  __typename?: 'EmailBlastLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  args?: Maybe<Scalars['JSON']>;
  recipientCount: Scalars['Float'];
  errorMsg?: Maybe<Scalars['String']>;
};

export type EntityContol = {
  noOfEntity?: Maybe<Scalars['Float']>;
  noofExtraEntity?: Maybe<Scalars['Float']>;
};

export type FileOutput = {
  __typename?: 'FileOutput';
  base64File?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
};

export type FromBankAccountEntity = {
  __typename?: 'FromBankAccountEntity';
  accountId: Scalars['String'];
  name: Scalars['String'];
  accountHolder: Scalars['String'];
  accountNo: Scalars['String'];
  branch: Scalars['String'];
  address: Scalars['JSON'];
  account: AccountEntity;
};

export type FromBankAccountInput = {
  accountHolder: Scalars['String'];
  accountNo: Scalars['String'];
  address: AddressInput;
  accountId: Scalars['String'];
  name: Scalars['String'];
  branch: Scalars['String'];
  ID?: Maybe<Scalars['String']>;
};

export type FromBankDetails = {
  __typename?: 'FromBankDetails';
  name?: Maybe<Scalars['String']>;
  acctHolder?: Maybe<Scalars['String']>;
  acctNo?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
};

export type FromBankDetailsInput = {
  name?: Maybe<Scalars['String']>;
  acctHolder?: Maybe<Scalars['String']>;
  acctNo?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
};

export type HuaweiStorageOutput = {
  __typename?: 'HuaweiStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};


export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String'];
  user: UserEntity;
};

export type Mutation = {
  __typename?: 'Mutation';
  insertDownloadLog: Scalars['Boolean'];
  markPostAsRead: Scalars['Boolean'];
  insertPaymentTransaction: PaymentTransactionOutputModel;
  createServiceRequest: Scalars['Boolean'];
  ProceedRequestQuotation: Scalars['Boolean'];
  CancelServiceRequest: Scalars['Boolean'];
  editUserAndRole: Scalars['Boolean'];
  editUserProfileContact: UserEntity;
};


export type MutationInsertDownloadLogArgs = {
  attachmentId?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  fileSize: Scalars['Float'];
  fileName: Scalars['String'];
};


export type MutationMarkPostAsReadArgs = {
  input: NewsFeedReadStatusInputType;
};


export type MutationInsertPaymentTransactionArgs = {
  paymentTransactionInput: PaymentTransactionInput;
};


export type MutationCreateServiceRequestArgs = {
  SRInput: ServiceRequestInputModel;
};


export type MutationProceedRequestQuotationArgs = {
  Reason?: Maybe<Scalars['String']>;
  RequestQuotationId: Scalars['String'];
};


export type MutationCancelServiceRequestArgs = {
  CancelServiceRequestModel: CancelServiceRequestModel;
};


export type MutationEditUserAndRoleArgs = {
  input: EditTenantUserAndRoleInput;
};


export type MutationEditUserProfileContactArgs = {
  input: UpdateUserProfileInput;
};

export type NewsFeedEntity = CoreBaseEntity & {
  __typename?: 'NewsFeedEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  feedTitle: Scalars['String'];
  feedContent: Scalars['String'];
  feedStatus?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  accountId: Scalars['String'];
  hasExpiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  lPropertyId?: Maybe<Scalars['Float']>;
  isPostToAll?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  commonStatus: CommonStatus;
  account: AccountEntity;
  newsFeedReadStatus?: Maybe<NewsFeedReadStatusEntity>;
  attachment?: Maybe<AttachmentEntity>;
  createdByUser?: Maybe<UserEntity>;
};

export type NewsFeedInputType = {
  id?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  feedTitle: Scalars['String'];
  feedContent: Scalars['String'];
  feedStatus: Scalars['String'];
  hasExpiry: Scalars['Boolean'];
  isPostToAll: Scalars['Boolean'];
  lPropertyId: Scalars['Float'];
  isTouched?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<Array<AttachmentModel>>;
};

export type NewsFeedReadStatusEntity = CoreBaseEntity & {
  __typename?: 'NewsFeedReadStatusEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  newsFeedId: Scalars['String'];
  commonStatus: CommonStatus;
  newsFeed?: Maybe<NewsFeedEntity>;
};

export type NewsFeedReadStatusInputType = {
  newsFeedId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  modBy?: Maybe<Scalars['String']>;
};

export type OnlineUserEntity = CoreBaseEntity & {
  __typename?: 'OnlineUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  userId: Scalars['String'];
  softwareId: Scalars['String'];
  accountId: Scalars['String'];
  entityId?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  lastLogin: Scalars['DateTime'];
  lastLogout?: Maybe<Scalars['DateTime']>;
  socketId?: Maybe<Scalars['String']>;
};

export type PackageEntity = CoreBaseEntity & {
  __typename?: 'PackageEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  softwareId: Scalars['String'];
  subscription: Array<SubscriptionEntity>;
  software: SoftwareEntity;
};

export type PackageInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  softwareId?: Maybe<Scalars['String']>;
};

export type PaymentTransactionDetails = {
  lBillId: Scalars['Float'];
  amount: Scalars['Float'];
  lDocumentNo: Scalars['String'];
  lBillItemName: Scalars['String'];
  lDocumentAmt: Scalars['Float'];
  lBalanceAmt?: Maybe<Scalars['Float']>;
  lChargeAmt?: Maybe<Scalars['Float']>;
  lTaxAmt?: Maybe<Scalars['Float']>;
  otherInfo?: Maybe<Scalars['JSON']>;
};

export type PaymentTransactionInput = {
  amount: Scalars['Float'];
  isDeposit: Scalars['Boolean'];
  details: Array<PaymentTransactionDetails>;
};

export type PaymentTransactionOutputModel = {
  __typename?: 'PaymentTransactionOutputModel';
  TransactionId: Scalars['String'];
  MerchantCode: Scalars['String'];
  RefNo: Scalars['String'];
  Currency: Scalars['String'];
  UserName: Scalars['String'];
  UserEmail: Scalars['String'];
  UserContact: Scalars['String'];
  SignatureType: Scalars['String'];
  Signature: Scalars['String'];
  UserId: Scalars['String'];
  AccountId: Scalars['String'];
  DebtorId: Scalars['Float'];
};

export type PermissionRoleEntity = CoreBaseEntity & {
  __typename?: 'PermissionRoleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  roleId: Scalars['String'];
  permissionId: Scalars['Float'];
  role: RoleEntity;
  permissionCode: Scalars['String'];
};

export type PostcodeEntity = CoreBaseEntity & {
  __typename?: 'PostcodeEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  postcode: Scalars['String'];
  cityId: Scalars['String'];
  commonStatus: CommonStatus;
  city: CityEntity;
};

export type PostcodeInput = {
  postcode?: Maybe<Scalars['String']>;
  cityID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getSubscriptionAccount?: Maybe<AccountEntity>;
  getAccountSetting?: Maybe<SAccountSettings>;
  AttachmentByRefIdAndRefTable?: Maybe<Array<AttachmentEntity>>;
  getPaymentTransactionByDebtorId?: Maybe<Array<SPaymentTransaction>>;
  DownloadInvoiceGroupFromLease365?: Maybe<FileOutput>;
  DownloadSoaFromLease365?: Maybe<FileOutput>;
  getAnnouncementsByPropertyId?: Maybe<Array<NewsFeedEntity>>;
  paymentTransactionById?: Maybe<SPaymentTransaction>;
  verifyPaymentTransactionStatusById: Scalars['String'];
  paymentTransactionDetailsByTransId?: Maybe<Array<SPaymentTransactionDetails>>;
  getRoleByAccountId: Array<RoleEntity>;
  requestActivityById?: Maybe<RequestActivity>;
  serviceRequestByDebtorId?: Maybe<Array<ServiceRequest>>;
  serviceRequestSummaryByDebtorId?: Maybe<ServiceRequestSummary>;
  serviceRequestById?: Maybe<ServiceRequest>;
  GetServiceRequestInputData: ServiceRequestCriteria;
  filteredServiceRequestByDebtorId?: Maybe<Array<ServiceRequest>>;
  getCloudRequestType: Array<RequestType>;
  getCloudPublicArea: Array<RequestPublicArea>;
  selectUsersById?: Maybe<UserEntity>;
  getUserAccountDebtor?: Maybe<Array<AccountDebtor>>;
  getUserRoleByUserId?: Maybe<Array<RoleEntity>>;
  getUserById?: Maybe<UserEntity>;
  getTenantUsersByAccountDebtor: Array<UserEntity>;
  getUserCountSummary: UserCountSummary;
  getUserProfile?: Maybe<UserEntity>;
};


export type QueryGetAccountSettingArgs = {
  settingKey: Scalars['String'];
};


export type QueryAttachmentByRefIdAndRefTableArgs = {
  input: AttachmentByRefIdAndRefTableInput;
};


export type QueryDownloadInvoiceGroupFromLease365Args = {
  DocNo: Scalars['String'];
  RefColumnName: Scalars['String'];
  RefRecordID: Scalars['Float'];
};


export type QueryDownloadSoaFromLease365Args = {
  EndDate: Scalars['String'];
  StartDate: Scalars['String'];
  DebtorIDs: Scalars['String'];
  PropertyIDs: Scalars['String'];
};


export type QueryGetAnnouncementsByPropertyIdArgs = {
  IsFindLatestPostDate?: Maybe<Scalars['Boolean']>;
  PropertyId: Scalars['Float'];
};


export type QueryPaymentTransactionByIdArgs = {
  TransactionId: Scalars['String'];
};


export type QueryVerifyPaymentTransactionStatusByIdArgs = {
  TransactionId: Scalars['String'];
};


export type QueryPaymentTransactionDetailsByTransIdArgs = {
  TransactionId: Scalars['String'];
};


export type QueryGetRoleByAccountIdArgs = {
  accountId?: Maybe<Scalars['String']>;
};


export type QueryRequestActivityByIdArgs = {
  ActivityId: Scalars['String'];
};


export type QueryServiceRequestByIdArgs = {
  RequestId: Scalars['String'];
};


export type QueryFilteredServiceRequestByDebtorIdArgs = {
  OrderBy: Scalars['String'];
  RequestStatus: Array<Scalars['String']>;
};


export type QueryGetUserRoleByUserIdArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type QueryGetUserByIdArgs = {
  userId: Scalars['String'];
};

export type Recipient = {
  __typename?: 'Recipient';
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export type ReportLogEntity = {
  __typename?: 'ReportLogEntity';
  ID: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  requestDate?: Maybe<Scalars['DateTime']>;
};

export type ReportLogInput = {
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type RequestActivity = CoreBaseEntity & {
  __typename?: 'RequestActivity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  assignId: Scalars['String'];
  tenantView: Scalars['Boolean'];
  remark?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  requestId: Scalars['String'];
  request: ServiceRequest;
  requestEstimation?: Maybe<RequestEstimation>;
  requestFollowUp?: Maybe<RequestFollowUp>;
  requestQuotation?: Maybe<RequestQuotation>;
  assignTo: UserEntity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
  getLatestTwoRequestQuotation?: Maybe<RequestQuotation>;
  requestStatus?: Maybe<Scalars['String']>;
};

export type RequestEstimation = CoreBaseEntity & {
  __typename?: 'RequestEstimation';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  processDate?: Maybe<Scalars['DateTime']>;
  completeDate?: Maybe<Scalars['DateTime']>;
  durationDay?: Maybe<Scalars['Float']>;
  durationHour?: Maybe<Scalars['Float']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestFollowUp = CoreBaseEntity & {
  __typename?: 'RequestFollowUp';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  activityDate: Scalars['DateTime'];
  appointDate?: Maybe<Scalars['DateTime']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestLog = CoreBaseEntity & {
  __typename?: 'RequestLog';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  logTenant?: Maybe<Scalars['String']>;
  logMall?: Maybe<Scalars['String']>;
  isShow: Scalars['Boolean'];
  requestId: Scalars['String'];
  requestActivityId: Scalars['String'];
  commonStatus: CommonStatus;
  requestStatus: Scalars['String'];
  requestActivity?: Maybe<RequestActivity>;
  request: ServiceRequest;
};


export type RequestLogRequestActivityArgs = {
  TenantView?: Maybe<Scalars['Boolean']>;
};

export type RequestPublicArea = CoreBaseEntity & {
  __typename?: 'RequestPublicArea';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo: Scalars['Float'];
  requestOfPublicArea: Array<ServiceRequest>;
};

export type RequestQuotation = CoreBaseEntity & {
  __typename?: 'RequestQuotation';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  isProceed?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  operatorName?: Maybe<Scalars['String']>;
  operatorContactNo?: Maybe<Scalars['String']>;
  operatorEmail?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<AttachmentEntity>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestType = CoreBaseEntity & {
  __typename?: 'RequestType';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo: Scalars['Float'];
  requestOfType: Array<ServiceRequest>;
};

export type RoleEntity = CoreBaseEntity & {
  __typename?: 'RoleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  name: Scalars['String'];
  account: AccountEntity;
  software?: Maybe<SoftwareEntity>;
  permissions?: Maybe<Array<PermissionRoleEntity>>;
  totalPermission: Scalars['Float'];
  users?: Maybe<Array<UserEntity>>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
};


export type RoleEntityRoleUsersArgs = {
  isByUserId?: Maybe<Scalars['Boolean']>;
};

export type RoleUserEntity = CoreBaseEntity & {
  __typename?: 'RoleUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  entityId: Scalars['String'];
  roleId: Scalars['String'];
  userId: Scalars['String'];
  account: AccountEntity;
  role: RoleEntity;
  user: UserEntity;
};

export type SAccountSettings = CoreBaseEntity & {
  __typename?: 'SAccountSettings';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  settingKey: Scalars['String'];
  settingValue: Scalars['String'];
  accountId: Scalars['String'];
  account: AccountEntity;
};

export type SApiGateway = CoreBaseEntity & {
  __typename?: 'SApiGateway';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  apiGatewayUrl?: Maybe<Scalars['String']>;
  tokenValidity?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  apiCallToken?: Maybe<Scalars['String']>;
  adminUserId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  accountId?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  account?: Maybe<AccountEntity>;
  software?: Maybe<SoftwareEntity>;
  lease365ApiUrl?: Maybe<Scalars['String']>;
  lease365ApiToken?: Maybe<Scalars['String']>;
  lease365ApiTokenExpiresAt?: Maybe<Scalars['String']>;
};

export type SGatewayUpdates = CoreBaseEntity & {
  __typename?: 'SGatewayUpdates';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  version: Scalars['String'];
  md5: Scalars['String'];
  hasSqlUpdate: Scalars['Boolean'];
  url: Scalars['String'];
  verifySql?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
};

export type SNumberFormat = CoreBaseEntity & {
  __typename?: 'SNumberFormat';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  numberTypeId: Scalars['String'];
  numberFormat: Scalars['String'];
  numberLength: Scalars['Float'];
  commonStatus: CommonStatus;
  account: AccountEntity;
  numberType: SNumberType;
  sRunningNumberSetups: Array<SRunningNumberSetup>;
  prefixCode: Scalars['String'];
};

export type SNumberType = CoreBaseEntity & {
  __typename?: 'SNumberType';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  numberCode: Scalars['String'];
  numberName: Scalars['String'];
  commonStatus: CommonStatus;
  sNumberFormats: Array<SNumberFormat>;
};

export type SPaymentTransaction = CoreBaseEntity & {
  __typename?: 'SPaymentTransaction';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  amount: Scalars['Float'];
  paymentMethod?: Maybe<Scalars['String']>;
  referenceNo: Scalars['String'];
  status: Scalars['String'];
  response?: Maybe<Scalars['JSON']>;
  paymentProvider?: Maybe<Scalars['String']>;
  isPendingIntegration: Scalars['Boolean'];
  noOfRetry: Scalars['Float'];
  integrationError?: Maybe<Scalars['String']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  account: AccountEntity;
  createdUser: UserEntity;
  isDeposit?: Maybe<Scalars['Boolean']>;
  transactionDetails?: Maybe<Array<SPaymentTransactionDetails>>;
};

export type SPaymentTransactionDetails = CoreBaseEntity & {
  __typename?: 'SPaymentTransactionDetails';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  sPaymentTransactionId: Scalars['String'];
  amount: Scalars['Float'];
  lBillId: Scalars['Float'];
  lDocumentNo: Scalars['String'];
  lBillItemName: Scalars['String'];
  lDocumentAmt: Scalars['Float'];
  lBalanceAmt?: Maybe<Scalars['Float']>;
  lChargeAmt?: Maybe<Scalars['Float']>;
  lTaxAmt?: Maybe<Scalars['Float']>;
  otherInfo?: Maybe<Scalars['JSON']>;
  transaction: SPaymentTransaction;
};

export type SRunningNumberSetup = CoreBaseEntity & {
  __typename?: 'SRunningNumberSetup';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  numberFormatId: Scalars['String'];
  accountId: Scalars['String'];
  nextNumber: Scalars['Float'];
  numberFormat: SNumberFormat;
};

export type ServiceDetail = CoreBaseEntity & {
  __typename?: 'ServiceDetail';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  request: ServiceRequest;
  attachment?: Maybe<AttachmentEntity>;
};

export type ServiceDetailModel = {
  message?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['Upload']>;
  isAttachment: Scalars['Boolean'];
};

export type ServiceDetailsMediaCount = {
  __typename?: 'ServiceDetailsMediaCount';
  ID?: Maybe<Scalars['String']>;
  textMediaCount?: Maybe<Scalars['Float']>;
  audioMediaCount?: Maybe<Scalars['Float']>;
  imageMediaCount?: Maybe<Scalars['Float']>;
  videoMediaCount?: Maybe<Scalars['Float']>;
};

export type ServiceRequest = CoreBaseEntity & {
  __typename?: 'ServiceRequest';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  lPropertyId: Scalars['Float'];
  lDebtorId?: Maybe<Scalars['Float']>;
  lUnitId?: Maybe<Scalars['Float']>;
  lastAssignId?: Maybe<Scalars['String']>;
  requestNo: Scalars['String'];
  requestStatus: Scalars['String'];
  publicAreaId?: Maybe<Scalars['String']>;
  requesterName: Scalars['String'];
  requesterContact?: Maybe<Scalars['String']>;
  requestTypeId?: Maybe<Scalars['String']>;
  requestTitle?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  accountId: Scalars['String'];
  isCancelled: Scalars['Boolean'];
  requestActivities?: Maybe<Array<RequestActivity>>;
  requestLogs: Array<RequestLog>;
  serviceDetails: Array<ServiceDetail>;
  account: AccountEntity;
  requestTypeData?: Maybe<RequestType>;
  publicAreaData?: Maybe<RequestPublicArea>;
  serviceDetailsMediaCount?: Maybe<ServiceDetailsMediaCount>;
  serviceRequestQuotationCount?: Maybe<ServiceRequestQuotationCount>;
  unitNo?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  createdUser?: Maybe<UserEntity>;
  lastAssignTo?: Maybe<Scalars['String']>;
  getLatestTwoRequestQuotation?: Maybe<Array<RequestQuotation>>;
  nextFollowUpDate?: Maybe<Scalars['DateTime']>;
  ServiceRequestReport?: Maybe<Array<BusinessInsightOutput>>;
};


export type ServiceRequestRequestLogsArgs = {
  IsShow?: Maybe<Scalars['Boolean']>;
};

export type ServiceRequestCriteria = {
  __typename?: 'ServiceRequestCriteria';
  serviceRequestAreaType: Array<Scalars['String']>;
  publicArea: Array<Scalars['String']>;
  unit: Array<UnitModel>;
};

export type ServiceRequestInputModel = {
  accountId?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['Float']>;
  publicAreaDesc?: Maybe<Scalars['String']>;
  serviceDetail?: Maybe<Array<ServiceDetailModel>>;
};

export type ServiceRequestQuotationCount = {
  __typename?: 'ServiceRequestQuotationCount';
  ID: Scalars['String'];
  quotationCount: Scalars['Float'];
};

export type ServiceRequestSummary = {
  __typename?: 'ServiceRequestSummary';
  lDebtorId?: Maybe<Scalars['Float']>;
  reportedCount?: Maybe<Scalars['Float']>;
  inProgressCount?: Maybe<Scalars['Float']>;
  resolvedCount?: Maybe<Scalars['Float']>;
  closedCount?: Maybe<Scalars['Float']>;
};

export type SoftwareDelInput = {
  ID: Scalars['String'];
};

export type SoftwareEntity = CoreBaseEntity & {
  __typename?: 'SoftwareEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  softwareAccount: UserAccSoftwareEntity;
  subscription: Array<SubscriptionEntity>;
  package: Array<PackageEntity>;
  termsConditions: Array<TermsConditionsEntity>;
  roles?: Maybe<Array<RoleEntity>>;
};

export type SoftwareInfo = {
  name: Scalars['String'];
  ID: Scalars['String'];
};

export type SoftwareInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<PackageInput>>;
};

export type SoftwareUpdateInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<PackageInput>>;
};

export type StateEntity = CoreBaseEntity & {
  __typename?: 'StateEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  countryId: Scalars['String'];
  commonStatus: CommonStatus;
  country: CountryEntity;
  city: Array<CityEntity>;
};

export type StateInput = {
  name?: Maybe<Scalars['String']>;
  countryID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type SubscriptionEntity = CoreBaseEntity & {
  __typename?: 'SubscriptionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  packageId?: Maybe<Scalars['String']>;
  softwareId: Scalars['String'];
  subscriptionAmt: Scalars['Float'];
  salesOrderNo: Scalars['String'];
  remark: Scalars['String'];
  terminationReason?: Maybe<Scalars['String']>;
  isTerminated: Scalars['Boolean'];
  saleOrderDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  noOfUser: Scalars['Float'];
  entityControl?: Maybe<Scalars['JSON']>;
  commonStatus: CommonStatus;
  /** CustomFieldResolver */
  daysToGo: Scalars['Float'];
  account: AccountEntity;
  software: SoftwareEntity;
  package: PackageEntity;
};

export type SubscriptionInput = {
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  subscriptionAmt: Scalars['Float'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  noOfUser: Scalars['Float'];
  saleOrderDate: Scalars['DateTime'];
  salesOrderNo: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  entityControl: EntityContol;
};

export type SubscriptionUpdateInput = {
  ID?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  subscriptionAmt?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  noOfUser?: Maybe<Scalars['Float']>;
  saleOrderDate?: Maybe<Scalars['DateTime']>;
  salesOrderNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  entityControl?: Maybe<EntityContol>;
  terminationReason?: Maybe<Scalars['String']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
};

export type TermsConditionsEntity = {
  __typename?: 'TermsConditionsEntity';
  name: Scalars['String'];
  softwareId: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  account: AccountEntity;
  software: SoftwareEntity;
};

export type TermsConditionsInput = {
  name: Scalars['String'];
  softwareId: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
};

export type TestPassword = CoreBaseEntity & {
  __typename?: 'TestPassword';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
};

export type TransactionsDetailsInput = {
  TransactionDetailsID: Scalars['String'];
  TransactionID: Scalars['String'];
  Amount: Scalars['Float'];
  BillID: Scalars['Float'];
};

export type TransactionsInput = {
  TransactionID: Scalars['String'];
  Amount: Scalars['Float'];
  TransactionDate: Scalars['String'];
  RefNo: Scalars['String'];
  DebtorID: Scalars['Float'];
  IsDeposit: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  TransactionsDetails: Array<TransactionsDetailsInput>;
};

export type Unit = {
  __typename?: 'Unit';
  unitId?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UnitModel = {
  __typename?: 'UnitModel';
  unitId?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UpdateAuditInput = {
  modBy?: Maybe<Scalars['String']>;
};

export type UpdateUserInput = {
  name?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  superUser?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  softwareInfo?: Maybe<Array<SoftwareInfo>>;
};

export type UpdateUserProfileInput = {
  name: Scalars['String'];
  contactNo?: Maybe<Scalars['String']>;
};


export type UserAccSoftwareEntity = CoreBaseEntity & {
  __typename?: 'UserAccSoftwareEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  userId: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  tokenVersion?: Maybe<Scalars['Float']>;
  lUserId?: Maybe<Scalars['Float']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  lCompanyId?: Maybe<Scalars['Float']>;
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  activatedDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  account: AccountEntity;
  user: UserEntity;
  software: SoftwareEntity;
};

export type UserActionLogEntity = {
  __typename?: 'UserActionLogEntity';
  ID: Scalars['String'];
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  actionId?: Maybe<Scalars['String']>;
  actionName?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  loginDateTime?: Maybe<Scalars['DateTime']>;
};

export type UserCountSummary = {
  __typename?: 'UserCountSummary';
  totalActiveUser: Scalars['Float'];
  totalUser: Scalars['Float'];
};

export type UserEntity = CoreBaseEntity & {
  __typename?: 'UserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['JSON']>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  pwdHistory?: Maybe<Scalars['JSON']>;
  is2FA: Scalars['Boolean'];
  totpSecret?: Maybe<Scalars['String']>;
  loginAttempt: Scalars['Float'];
  blockDuration: Scalars['Float'];
  blockCount: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  deviceIP?: Maybe<Scalars['String']>;
  softwareAccount: Array<UserAccSoftwareEntity>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
  paymentTransactions?: Maybe<Array<SPaymentTransaction>>;
  userNewsFeed?: Maybe<NewsFeedEntity>;
  account: Array<AccountEntity>;
  software: Array<SoftwareEntity>;
  tenantAccountName: Scalars['String'];
};

export type UserInput = {
  name: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  contactNo: Scalars['String'];
  address?: Maybe<AddressInput>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
  superUser?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  softwareInfo: Array<SoftwareInfo>;
};

export type UserOutput = {
  __typename?: 'UserOutput';
  userName?: Maybe<Scalars['String']>;
  handPhone?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  loginName?: Maybe<Scalars['String']>;
  companyData?: Maybe<CompanyData>;
  userId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
};

export type LastAssignToOfServiceRequestDataLoaderInput = {
  __typename?: 'lastAssignToOfServiceRequestDataLoaderInput';
  lastAssignId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type TenantNameOfServiceRequestDataLoaderInput = {
  __typename?: 'tenantNameOfServiceRequestDataLoaderInput';
  debtorId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type UnitOfServiceRequestDataLoaderInput = {
  __typename?: 'unitOfServiceRequestDataLoaderInput';
  unitId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type ValidateUserForPaymentQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ValidateUserForPaymentQuery = (
  { __typename?: 'Query' }
  & { getUserById?: Maybe<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'contactNo'>
  )> }
);

export type GetUserAccountDebtorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountDebtorQuery = (
  { __typename?: 'Query' }
  & { getUserAccountDebtor?: Maybe<Array<(
    { __typename?: 'AccountDebtor' }
    & Pick<AccountDebtor, 'contractLotNo' | 'accountId' | 'debtorAccountName' | 'lDebtorId' | 'propertyName'>
  )>> }
);

export type GetUserPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPermissionQuery = (
  { __typename?: 'Query' }
  & { getUserRoleByUserId?: Maybe<Array<(
    { __typename?: 'RoleEntity' }
    & Pick<RoleEntity, 'name'>
    & { permissions?: Maybe<Array<(
      { __typename?: 'PermissionRoleEntity' }
      & Pick<PermissionRoleEntity, 'permissionCode'>
    )>> }
  )>> }
);

export type GetPaymentTransactionByDebtorIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentTransactionByDebtorIdQuery = (
  { __typename?: 'Query' }
  & { getPaymentTransactionByDebtorId?: Maybe<Array<(
    { __typename?: 'SPaymentTransaction' }
    & Pick<SPaymentTransaction, 'ID' | 'transactionDate' | 'referenceNo' | 'amount' | 'isDeposit' | 'response'>
  )>> }
);

export type GetPaymentTransactionByIdQueryVariables = Exact<{
  TransactionId: Scalars['String'];
}>;


export type GetPaymentTransactionByIdQuery = (
  { __typename?: 'Query' }
  & { paymentTransactionById?: Maybe<(
    { __typename?: 'SPaymentTransaction' }
    & Pick<SPaymentTransaction, 'ID' | 'accountId' | 'transactionDate' | 'amount' | 'paymentMethod' | 'referenceNo' | 'status' | 'response' | 'paymentProvider' | 'isPendingIntegration' | 'noOfRetry' | 'integrationError' | 'lDebtorId'>
    & { transactionDetails?: Maybe<Array<(
      { __typename?: 'SPaymentTransactionDetails' }
      & Pick<SPaymentTransactionDetails, 'ID' | 'amount' | 'lBillId' | 'lDocumentNo' | 'lBillItemName' | 'lDocumentAmt' | 'lBalanceAmt' | 'lChargeAmt' | 'lTaxAmt' | 'otherInfo'>
    )>> }
  )> }
);

export type GetDashboardCloudQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardCloudQuery = (
  { __typename?: 'Query' }
  & { serviceRequestSummaryByDebtorId?: Maybe<(
    { __typename?: 'ServiceRequestSummary' }
    & Pick<ServiceRequestSummary, 'reportedCount' | 'inProgressCount' | 'resolvedCount' | 'closedCount'>
  )>, getUserCountSummary: (
    { __typename?: 'UserCountSummary' }
    & Pick<UserCountSummary, 'totalUser'>
  ) }
);

export type GetLatestPostDateQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  IsFindLatestPostDate?: Maybe<Scalars['Boolean']>;
}>;


export type GetLatestPostDateQuery = (
  { __typename?: 'Query' }
  & { getAnnouncementsByPropertyId?: Maybe<Array<(
    { __typename?: 'NewsFeedEntity' }
    & Pick<NewsFeedEntity, 'publishDate'>
  )>> }
);

export type SelectUsersByIdQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectUsersByIdQuery = (
  { __typename?: 'Query' }
  & { selectUsersById?: Maybe<(
    { __typename?: 'UserEntity' }
    & { account: Array<(
      { __typename?: 'AccountEntity' }
      & { newsFeed: Array<(
        { __typename?: 'NewsFeedEntity' }
        & { newsFeedReadStatus?: Maybe<(
          { __typename?: 'NewsFeedReadStatusEntity' }
          & Pick<NewsFeedReadStatusEntity, 'ID'>
        )> }
      )> }
    )> }
  )> }
);

export type GetAnnouncementsByPropertyIdQueryVariables = Exact<{
  PropertyId: Scalars['Float'];
  IsFindLatestPostDate?: Maybe<Scalars['Boolean']>;
}>;


export type GetAnnouncementsByPropertyIdQuery = (
  { __typename?: 'Query' }
  & { getAnnouncementsByPropertyId?: Maybe<Array<(
    { __typename?: 'NewsFeedEntity' }
    & Pick<NewsFeedEntity, 'ID' | 'feedTitle' | 'feedContent' | 'feedStatus' | 'publishDate' | 'hasExpiry' | 'expiryDate'>
    & { attachment?: Maybe<(
      { __typename?: 'AttachmentEntity' }
      & Pick<AttachmentEntity, 'fileName' | 'mediaType' | 'resourceUrl'>
    )>, newsFeedReadStatus?: Maybe<(
      { __typename?: 'NewsFeedReadStatusEntity' }
      & Pick<NewsFeedReadStatusEntity, 'createdBy' | 'newsFeedId'>
    )>, createdByUser?: Maybe<(
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'name'>
    )> }
  )>> }
);

export type MarkPostAsReadMutationVariables = Exact<{
  input: NewsFeedReadStatusInputType;
}>;


export type MarkPostAsReadMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'markPostAsRead'>
);

export type GetPaymentConfirmationInfoQueryVariables = Exact<{
  userId: Scalars['String'];
  settingKey: Scalars['String'];
}>;


export type GetPaymentConfirmationInfoQuery = (
  { __typename?: 'Query' }
  & { getSubscriptionAccount?: Maybe<(
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'email' | 'contactNo' | 'name' | 'regNo' | 'address'>
  )>, getUserById?: Maybe<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'contactNo'>
  )>, getAccountSetting?: Maybe<(
    { __typename?: 'SAccountSettings' }
    & Pick<SAccountSettings, 'ID' | 'settingValue'>
  )> }
);

export type GetPaymentResultQueryVariables = Exact<{
  transactionId: Scalars['String'];
}>;


export type GetPaymentResultQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'verifyPaymentTransactionStatusById'>
  & { paymentTransactionById?: Maybe<(
    { __typename?: 'SPaymentTransaction' }
    & Pick<SPaymentTransaction, 'ID' | 'referenceNo' | 'status' | 'transactionDate' | 'amount'>
    & { createdUser: (
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'name'>
    ) }
  )>, getSubscriptionAccount?: Maybe<(
    { __typename?: 'AccountEntity' }
    & Pick<AccountEntity, 'ID' | 'email' | 'contactNo' | 'name' | 'regNo' | 'address'>
  )> }
);

export type InsertPaymentTransactionMutationVariables = Exact<{
  paymentTransactionInput: PaymentTransactionInput;
}>;


export type InsertPaymentTransactionMutation = (
  { __typename?: 'Mutation' }
  & { insertPaymentTransaction: (
    { __typename?: 'PaymentTransactionOutputModel' }
    & Pick<PaymentTransactionOutputModel, 'TransactionId' | 'MerchantCode' | 'RefNo' | 'SignatureType' | 'UserContact' | 'UserEmail' | 'Signature' | 'UserName' | 'UserId' | 'AccountId' | 'DebtorId' | 'Currency'>
  ) }
);

export type PaymentTransactionDetailsByTransIdQueryVariables = Exact<{
  transactionId: Scalars['String'];
}>;


export type PaymentTransactionDetailsByTransIdQuery = (
  { __typename?: 'Query' }
  & { paymentTransactionDetailsByTransId?: Maybe<Array<(
    { __typename?: 'SPaymentTransactionDetails' }
    & Pick<SPaymentTransactionDetails, 'ID' | 'sPaymentTransactionId' | 'amount' | 'lBillId'>
  )>> }
);

export type CreateServiceRequestMutationVariables = Exact<{
  input: ServiceRequestInputModel;
}>;


export type CreateServiceRequestMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createServiceRequest'>
);

export type GetRequestInfoByDebtorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestInfoByDebtorQuery = (
  { __typename?: 'Query' }
  & { serviceRequestByDebtorId?: Maybe<Array<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'requestNo' | 'requestStatus'>
    & { requestTime: ServiceRequest['createdTs'], recordStatus: ServiceRequest['commonStatus'] }
  )>> }
);

export type GetRequestByRequestIdQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type GetRequestByRequestIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestById?: Maybe<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'requestNo' | 'requestStatus' | 'unitNo'>
    & { requestTime: ServiceRequest['createdTs'], recordStatus: ServiceRequest['commonStatus'], areaDescription: ServiceRequest['publicAreaId'] }
    & { requestTypeData?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'name'>
    )>, publicAreaData?: Maybe<(
      { __typename?: 'RequestPublicArea' }
      & Pick<RequestPublicArea, 'name'>
    )>, serviceDetails: Array<(
      { __typename?: 'ServiceDetail' }
      & Pick<ServiceDetail, 'ID' | 'message'>
      & { attachment?: Maybe<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'mediaType' | 'fileName' | 'bucketFileName' | 'resourceUrl'>
      )> }
    )>, serviceRequestQuotationCount?: Maybe<(
      { __typename?: 'ServiceRequestQuotationCount' }
      & Pick<ServiceRequestQuotationCount, 'ID' | 'quotationCount'>
    )>, requestLogs: Array<(
      { __typename?: 'RequestLog' }
      & Pick<RequestLog, 'ID' | 'createdTs'>
      & { requestActivity?: Maybe<(
        { __typename?: 'RequestActivity' }
        & Pick<RequestActivity, 'ID'>
        & { requestQuotation?: Maybe<(
          { __typename?: 'RequestQuotation' }
          & Pick<RequestQuotation, 'ID' | 'operatorName' | 'operatorContactNo' | 'operatorEmail'>
          & { attachment?: Maybe<(
            { __typename?: 'AttachmentEntity' }
            & Pick<AttachmentEntity, 'ID' | 'fileName' | 'resourceUrl' | 'fileSize'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type GetServiceRequestInputDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceRequestInputDataQuery = (
  { __typename?: 'Query' }
  & { GetServiceRequestInputData: (
    { __typename?: 'ServiceRequestCriteria' }
    & Pick<ServiceRequestCriteria, 'serviceRequestAreaType' | 'publicArea'>
    & { unit: Array<(
      { __typename?: 'UnitModel' }
      & Pick<UnitModel, 'unitId' | 'unitNo'>
    )> }
  ) }
);

export type GetServiceRequestSummaryByDebtorIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceRequestSummaryByDebtorIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestSummaryByDebtorId?: Maybe<(
    { __typename?: 'ServiceRequestSummary' }
    & Pick<ServiceRequestSummary, 'lDebtorId' | 'reportedCount' | 'inProgressCount' | 'resolvedCount' | 'closedCount'>
  )> }
);

export type GetServiceRequestListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceRequestListingQuery = (
  { __typename?: 'Query' }
  & { serviceRequestByDebtorId?: Maybe<Array<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'requestNo' | 'requestTitle' | 'createdTs' | 'requestStatus' | 'lDebtorId' | 'unitNo'>
    & { areaDescription: ServiceRequest['publicAreaId'] }
    & { serviceRequestQuotationCount?: Maybe<(
      { __typename?: 'ServiceRequestQuotationCount' }
      & Pick<ServiceRequestQuotationCount, 'ID' | 'quotationCount'>
    )>, serviceDetailsMediaCount?: Maybe<(
      { __typename?: 'ServiceDetailsMediaCount' }
      & Pick<ServiceDetailsMediaCount, 'textMediaCount' | 'audioMediaCount' | 'imageMediaCount' | 'videoMediaCount'>
    )> }
  )>> }
);

export type GetRequestLogByRequestIdQueryVariables = Exact<{
  requestId: Scalars['String'];
  tenantView: Scalars['Boolean'];
}>;


export type GetRequestLogByRequestIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestById?: Maybe<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'unitNo' | 'requestNo' | 'createdTs' | 'requestStatus'>
    & { areaDescription: ServiceRequest['publicAreaId'] }
    & { requestTypeData?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'name'>
    )>, publicAreaData?: Maybe<(
      { __typename?: 'RequestPublicArea' }
      & Pick<RequestPublicArea, 'name'>
    )>, requestLogs: Array<(
      { __typename?: 'RequestLog' }
      & Pick<RequestLog, 'ID' | 'logTenant' | 'createdTs' | 'requestStatus'>
      & { requestActivity?: Maybe<(
        { __typename?: 'RequestActivity' }
        & Pick<RequestActivity, 'ID' | 'numberOfAttachment'>
        & { assignTo: (
          { __typename?: 'UserEntity' }
          & Pick<UserEntity, 'name'>
        ), requestFollowUp?: Maybe<(
          { __typename?: 'RequestFollowUp' }
          & Pick<RequestFollowUp, 'ID' | 'numberOfAttachment'>
        )>, requestQuotation?: Maybe<(
          { __typename?: 'RequestQuotation' }
          & Pick<RequestQuotation, 'ID' | 'numberOfAttachment'>
        )>, requestEstimation?: Maybe<(
          { __typename?: 'RequestEstimation' }
          & Pick<RequestEstimation, 'ID' | 'numberOfAttachment'>
        )> }
      )> }
    )> }
  )> }
);

export type GetRequestDetailQuotationByRequestIdQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type GetRequestDetailQuotationByRequestIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestById?: Maybe<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'unitNo' | 'requestNo' | 'createdTs' | 'requestStatus'>
    & { areaDescription: ServiceRequest['publicAreaId'] }
    & { requestTypeData?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'name'>
    )>, publicAreaData?: Maybe<(
      { __typename?: 'RequestPublicArea' }
      & Pick<RequestPublicArea, 'name'>
    )>, requestActivities?: Maybe<Array<(
      { __typename?: 'RequestActivity' }
      & Pick<RequestActivity, 'ID'>
      & { requestQuotation?: Maybe<(
        { __typename?: 'RequestQuotation' }
        & Pick<RequestQuotation, 'ID' | 'operatorContactNo' | 'operatorEmail' | 'operatorName' | 'isProceed'>
        & { attachment?: Maybe<(
          { __typename?: 'AttachmentEntity' }
          & Pick<AttachmentEntity, 'ID' | 'fileName' | 'resourceUrl' | 'fileSize'>
        )> }
      )> }
    )>> }
  )> }
);

export type GetQuotationByRequestIdQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type GetQuotationByRequestIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestById?: Maybe<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID'>
    & { requestActivities?: Maybe<Array<(
      { __typename?: 'RequestActivity' }
      & Pick<RequestActivity, 'ID'>
      & { requestQuotation?: Maybe<(
        { __typename?: 'RequestQuotation' }
        & Pick<RequestQuotation, 'ID' | 'operatorContactNo' | 'operatorEmail' | 'operatorName'>
        & { attachment?: Maybe<(
          { __typename?: 'AttachmentEntity' }
          & Pick<AttachmentEntity, 'ID' | 'fileName' | 'resourceUrl' | 'fileSize'>
        )> }
      )> }
    )>> }
  )> }
);

export type GetServiceDetailAttachmentByRequestIdQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type GetServiceDetailAttachmentByRequestIdQuery = (
  { __typename?: 'Query' }
  & { serviceRequestById?: Maybe<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID'>
    & { serviceDetails: Array<(
      { __typename?: 'ServiceDetail' }
      & Pick<ServiceDetail, 'ID' | 'message'>
      & { attachment?: Maybe<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'mediaType' | 'fileName' | 'resourceUrl'>
      )> }
    )> }
  )> }
);

export type GetRequestActivityByIdQueryVariables = Exact<{
  ActivityId: Scalars['String'];
}>;


export type GetRequestActivityByIdQuery = (
  { __typename?: 'Query' }
  & { requestActivityById?: Maybe<(
    { __typename?: 'RequestActivity' }
    & Pick<RequestActivity, 'ID' | 'requestStatus' | 'remark' | 'createdTs'>
    & { assignTo: (
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'ID' | 'name'>
    ), attachment?: Maybe<Array<(
      { __typename?: 'AttachmentEntity' }
      & Pick<AttachmentEntity, 'ID' | 'fileName' | 'mediaType' | 'resourceUrl'>
    )>>, requestFollowUp?: Maybe<(
      { __typename?: 'RequestFollowUp' }
      & Pick<RequestFollowUp, 'ID' | 'activityDate' | 'appointDate'>
      & { attachment?: Maybe<Array<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'fileName' | 'mediaType' | 'resourceUrl'>
      )>> }
    )>, requestQuotation?: Maybe<(
      { __typename?: 'RequestQuotation' }
      & Pick<RequestQuotation, 'ID' | 'isProceed' | 'reason' | 'operatorName' | 'operatorContactNo' | 'operatorEmail'>
      & { attachment?: Maybe<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'fileName' | 'mediaType' | 'resourceUrl'>
      )> }
    )>, requestEstimation?: Maybe<(
      { __typename?: 'RequestEstimation' }
      & Pick<RequestEstimation, 'ID' | 'processDate' | 'completeDate' | 'durationDay' | 'durationHour'>
      & { attachment?: Maybe<Array<(
        { __typename?: 'AttachmentEntity' }
        & Pick<AttachmentEntity, 'ID' | 'fileName' | 'mediaType' | 'resourceUrl'>
      )>> }
    )> }
  )> }
);

export type GetRequestActvityAttachmentQueryVariables = Exact<{
  input: AttachmentByRefIdAndRefTableInput;
}>;


export type GetRequestActvityAttachmentQuery = (
  { __typename?: 'Query' }
  & { AttachmentByRefIdAndRefTable?: Maybe<Array<(
    { __typename?: 'AttachmentEntity' }
    & Pick<AttachmentEntity, 'ID' | 'mediaType' | 'resourceUrl' | 'fileName' | 'fileSize'>
  )>> }
);

export type GetFilteredServiceRequestListingQueryVariables = Exact<{
  RequestStatus: Array<Scalars['String']> | Scalars['String'];
  OrderBy: Scalars['String'];
}>;


export type GetFilteredServiceRequestListingQuery = (
  { __typename?: 'Query' }
  & { filteredServiceRequestByDebtorId?: Maybe<Array<(
    { __typename?: 'ServiceRequest' }
    & Pick<ServiceRequest, 'ID' | 'requestNo' | 'requestTitle' | 'createdTs' | 'requestStatus' | 'lDebtorId' | 'unitNo'>
    & { areaDescription: ServiceRequest['publicAreaId'] }
    & { requestTypeData?: Maybe<(
      { __typename?: 'RequestType' }
      & Pick<RequestType, 'name'>
    )>, publicAreaData?: Maybe<(
      { __typename?: 'RequestPublicArea' }
      & Pick<RequestPublicArea, 'name'>
    )>, serviceRequestQuotationCount?: Maybe<(
      { __typename?: 'ServiceRequestQuotationCount' }
      & Pick<ServiceRequestQuotationCount, 'ID' | 'quotationCount'>
    )>, serviceDetailsMediaCount?: Maybe<(
      { __typename?: 'ServiceDetailsMediaCount' }
      & Pick<ServiceDetailsMediaCount, 'ID' | 'textMediaCount' | 'audioMediaCount' | 'imageMediaCount' | 'videoMediaCount'>
    )> }
  )>> }
);

export type ProceedRequestQuotationMutationVariables = Exact<{
  RequestQuotationId: Scalars['String'];
  Reason?: Maybe<Scalars['String']>;
}>;


export type ProceedRequestQuotationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'ProceedRequestQuotation'>
);

export type CancelServiceRequestMutationVariables = Exact<{
  input: CancelServiceRequestModel;
}>;


export type CancelServiceRequestMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'CancelServiceRequest'>
);

export type InsertDownloadLogMutationVariables = Exact<{
  fileSize: Scalars['Float'];
  fileName: Scalars['String'];
  attachmentId?: Maybe<Scalars['String']>;
  path: Scalars['String'];
}>;


export type InsertDownloadLogMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'insertDownloadLog'>
);

export type GetCloudRequestTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCloudRequestTypeQuery = (
  { __typename?: 'Query' }
  & { getCloudRequestType: Array<(
    { __typename?: 'RequestType' }
    & Pick<RequestType, 'name' | 'seqNo' | 'ID'>
  )> }
);

export type GetCloudPublicAreaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCloudPublicAreaQuery = (
  { __typename?: 'Query' }
  & { getCloudPublicArea: Array<(
    { __typename?: 'RequestPublicArea' }
    & Pick<RequestPublicArea, 'name' | 'seqNo' | 'ID'>
  )> }
);

export type GetUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserListQuery = (
  { __typename?: 'Query' }
  & { getTenantUsersByAccountDebtor: Array<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'name' | 'email'>
  )> }
);

export type GetRoleListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleListQuery = (
  { __typename?: 'Query' }
  & { getRoleByAccountId: Array<(
    { __typename?: 'RoleEntity' }
    & Pick<RoleEntity, 'ID' | 'name'>
  )> }
);

export type GetUserDetailQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserDetailQuery = (
  { __typename?: 'Query' }
  & { getUserById?: Maybe<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'email' | 'name' | 'contactNo' | 'confirmed'>
  )>, getUserRoleByUserId?: Maybe<Array<(
    { __typename?: 'RoleEntity' }
    & Pick<RoleEntity, 'ID' | 'name'>
  )>> }
);

export type EditUserAndRoleMutationVariables = Exact<{
  input: EditTenantUserAndRoleInput;
}>;


export type EditUserAndRoleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editUserAndRole'>
);

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = (
  { __typename?: 'Query' }
  & { getUserProfile?: Maybe<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'name' | 'email' | 'contactNo'>
  )> }
);

export type EditUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type EditUserProfileMutation = (
  { __typename?: 'Mutation' }
  & { editUserProfileContact: (
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'name' | 'email' | 'contactNo'>
  ) }
);

export const ValidateUserForPaymentDocument = gql`
    query ValidateUserForPayment($userId: String!) {
  getUserById(userId: $userId) {
    contactNo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateUserForPaymentGQL extends Apollo.Query<ValidateUserForPaymentQuery, ValidateUserForPaymentQueryVariables> {
    document = ValidateUserForPaymentDocument;
    client = 'cloud';
  }
export const GetUserAccountDebtorDocument = gql`
    query getUserAccountDebtor {
  getUserAccountDebtor {
    contractLotNo
    accountId
    debtorAccountName
    lDebtorId
    propertyName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserAccountDebtorGQL extends Apollo.Query<GetUserAccountDebtorQuery, GetUserAccountDebtorQueryVariables> {
    document = GetUserAccountDebtorDocument;
    client = 'cloud';
  }
export const GetUserPermissionDocument = gql`
    query GetUserPermission {
  getUserRoleByUserId {
    name
    permissions {
      permissionCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserPermissionGQL extends Apollo.Query<GetUserPermissionQuery, GetUserPermissionQueryVariables> {
    document = GetUserPermissionDocument;
    client = 'cloud';
  }
export const GetPaymentTransactionByDebtorIdDocument = gql`
    query GetPaymentTransactionByDebtorId {
  getPaymentTransactionByDebtorId {
    ID
    transactionDate
    referenceNo
    amount
    isDeposit
    response
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentTransactionByDebtorIdGQL extends Apollo.Query<GetPaymentTransactionByDebtorIdQuery, GetPaymentTransactionByDebtorIdQueryVariables> {
    document = GetPaymentTransactionByDebtorIdDocument;
    client = 'cloud';
  }
export const GetPaymentTransactionByIdDocument = gql`
    query GetPaymentTransactionById($TransactionId: String!) {
  paymentTransactionById(TransactionId: $TransactionId) {
    ID
    accountId
    transactionDate
    amount
    paymentMethod
    referenceNo
    status
    response
    paymentProvider
    isPendingIntegration
    noOfRetry
    integrationError
    lDebtorId
    transactionDetails {
      ID
      amount
      lBillId
      lDocumentNo
      lBillItemName
      lDocumentAmt
      lBalanceAmt
      lChargeAmt
      lTaxAmt
      otherInfo
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentTransactionByIdGQL extends Apollo.Query<GetPaymentTransactionByIdQuery, GetPaymentTransactionByIdQueryVariables> {
    document = GetPaymentTransactionByIdDocument;
    client = 'cloud';
  }
export const GetDashboardCloudDocument = gql`
    query GetDashboardCloud {
  serviceRequestSummaryByDebtorId {
    reportedCount
    inProgressCount
    resolvedCount
    closedCount
  }
  getUserCountSummary {
    totalUser
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDashboardCloudGQL extends Apollo.Query<GetDashboardCloudQuery, GetDashboardCloudQueryVariables> {
    document = GetDashboardCloudDocument;
    client = 'cloud';
  }
export const GetLatestPostDateDocument = gql`
    query GetLatestPostDate($PropertyId: Float!, $IsFindLatestPostDate: Boolean) {
  getAnnouncementsByPropertyId(
    PropertyId: $PropertyId
    IsFindLatestPostDate: $IsFindLatestPostDate
  ) {
    publishDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLatestPostDateGQL extends Apollo.Query<GetLatestPostDateQuery, GetLatestPostDateQueryVariables> {
    document = GetLatestPostDateDocument;
    client = 'cloud';
  }
export const SelectUsersByIdDocument = gql`
    query selectUsersById {
  selectUsersById {
    account {
      newsFeed {
        newsFeedReadStatus {
          ID
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SelectUsersByIdGQL extends Apollo.Query<SelectUsersByIdQuery, SelectUsersByIdQueryVariables> {
    document = SelectUsersByIdDocument;
    client = 'cloud';
  }
export const GetAnnouncementsByPropertyIdDocument = gql`
    query GetAnnouncementsByPropertyId($PropertyId: Float!, $IsFindLatestPostDate: Boolean) {
  getAnnouncementsByPropertyId(
    PropertyId: $PropertyId
    IsFindLatestPostDate: $IsFindLatestPostDate
  ) {
    ID
    feedTitle
    feedContent
    feedStatus
    publishDate
    hasExpiry
    expiryDate
    attachment {
      fileName
      mediaType
      resourceUrl
    }
    newsFeedReadStatus {
      createdBy
      newsFeedId
    }
    createdByUser {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAnnouncementsByPropertyIdGQL extends Apollo.Query<GetAnnouncementsByPropertyIdQuery, GetAnnouncementsByPropertyIdQueryVariables> {
    document = GetAnnouncementsByPropertyIdDocument;
    client = 'cloud';
  }
export const MarkPostAsReadDocument = gql`
    mutation markPostAsRead($input: NewsFeedReadStatusInputType!) {
  markPostAsRead(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkPostAsReadGQL extends Apollo.Mutation<MarkPostAsReadMutation, MarkPostAsReadMutationVariables> {
    document = MarkPostAsReadDocument;
    client = 'cloud';
  }
export const GetPaymentConfirmationInfoDocument = gql`
    query GetPaymentConfirmationInfo($userId: String!, $settingKey: String!) {
  getSubscriptionAccount {
    ID
    email
    contactNo
    name
    regNo
    address
  }
  getUserById(userId: $userId) {
    contactNo
  }
  getAccountSetting(settingKey: $settingKey) {
    ID
    settingValue
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentConfirmationInfoGQL extends Apollo.Query<GetPaymentConfirmationInfoQuery, GetPaymentConfirmationInfoQueryVariables> {
    document = GetPaymentConfirmationInfoDocument;
    client = 'cloud';
  }
export const GetPaymentResultDocument = gql`
    query GetPaymentResult($transactionId: String!) {
  paymentTransactionById(TransactionId: $transactionId) {
    ID
    referenceNo
    status
    transactionDate
    amount
    createdUser {
      name
    }
  }
  verifyPaymentTransactionStatusById(TransactionId: $transactionId)
  getSubscriptionAccount {
    ID
    email
    contactNo
    name
    regNo
    address
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentResultGQL extends Apollo.Query<GetPaymentResultQuery, GetPaymentResultQueryVariables> {
    document = GetPaymentResultDocument;
    client = 'cloud';
  }
export const InsertPaymentTransactionDocument = gql`
    mutation insertPaymentTransaction($paymentTransactionInput: PaymentTransactionInput!) {
  insertPaymentTransaction(paymentTransactionInput: $paymentTransactionInput) {
    TransactionId
    MerchantCode
    RefNo
    SignatureType
    UserContact
    UserEmail
    Signature
    UserName
    UserId
    AccountId
    DebtorId
    Currency
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertPaymentTransactionGQL extends Apollo.Mutation<InsertPaymentTransactionMutation, InsertPaymentTransactionMutationVariables> {
    document = InsertPaymentTransactionDocument;
    client = 'cloud';
  }
export const PaymentTransactionDetailsByTransIdDocument = gql`
    query PaymentTransactionDetailsByTransId($transactionId: String!) {
  paymentTransactionDetailsByTransId(TransactionId: $transactionId) {
    ID
    sPaymentTransactionId
    amount
    lBillId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentTransactionDetailsByTransIdGQL extends Apollo.Query<PaymentTransactionDetailsByTransIdQuery, PaymentTransactionDetailsByTransIdQueryVariables> {
    document = PaymentTransactionDetailsByTransIdDocument;
    client = 'cloud';
  }
export const CreateServiceRequestDocument = gql`
    mutation createServiceRequest($input: ServiceRequestInputModel!) {
  createServiceRequest(SRInput: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateServiceRequestGQL extends Apollo.Mutation<CreateServiceRequestMutation, CreateServiceRequestMutationVariables> {
    document = CreateServiceRequestDocument;
    client = 'cloud';
  }
export const GetRequestInfoByDebtorDocument = gql`
    query GetRequestInfoByDebtor {
  serviceRequestByDebtorId {
    ID
    requestNo
    requestTime: createdTs
    requestStatus
    recordStatus: commonStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestInfoByDebtorGQL extends Apollo.Query<GetRequestInfoByDebtorQuery, GetRequestInfoByDebtorQueryVariables> {
    document = GetRequestInfoByDebtorDocument;
    client = 'cloud';
  }
export const GetRequestByRequestIdDocument = gql`
    query GetRequestByRequestId($requestId: String!) {
  serviceRequestById(RequestId: $requestId) {
    ID
    requestNo
    requestTime: createdTs
    requestStatus
    recordStatus: commonStatus
    unitNo
    areaDescription: publicAreaId
    requestTypeData {
      name
    }
    publicAreaData {
      name
    }
    serviceDetails {
      ID
      message
      attachment {
        ID
        mediaType
        fileName
        bucketFileName
        resourceUrl
      }
    }
    serviceRequestQuotationCount {
      ID
      quotationCount
    }
    requestLogs {
      ID
      createdTs
      requestActivity {
        ID
        requestQuotation {
          ID
          operatorName
          operatorContactNo
          operatorEmail
          attachment {
            ID
            fileName
            resourceUrl
            fileSize
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestByRequestIdGQL extends Apollo.Query<GetRequestByRequestIdQuery, GetRequestByRequestIdQueryVariables> {
    document = GetRequestByRequestIdDocument;
    client = 'cloud';
  }
export const GetServiceRequestInputDataDocument = gql`
    query GetServiceRequestInputData {
  GetServiceRequestInputData {
    serviceRequestAreaType
    publicArea
    unit {
      unitId
      unitNo
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceRequestInputDataGQL extends Apollo.Query<GetServiceRequestInputDataQuery, GetServiceRequestInputDataQueryVariables> {
    document = GetServiceRequestInputDataDocument;
    client = 'cloud';
  }
export const GetServiceRequestSummaryByDebtorIdDocument = gql`
    query getServiceRequestSummaryByDebtorId {
  serviceRequestSummaryByDebtorId {
    lDebtorId
    reportedCount
    inProgressCount
    resolvedCount
    closedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceRequestSummaryByDebtorIdGQL extends Apollo.Query<GetServiceRequestSummaryByDebtorIdQuery, GetServiceRequestSummaryByDebtorIdQueryVariables> {
    document = GetServiceRequestSummaryByDebtorIdDocument;
    client = 'cloud';
  }
export const GetServiceRequestListingDocument = gql`
    query getServiceRequestListing {
  serviceRequestByDebtorId {
    ID
    requestNo
    requestTitle
    createdTs
    requestStatus
    lDebtorId
    unitNo
    areaDescription: publicAreaId
    serviceRequestQuotationCount {
      ID
      quotationCount
    }
    serviceDetailsMediaCount {
      textMediaCount
      audioMediaCount
      imageMediaCount
      videoMediaCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceRequestListingGQL extends Apollo.Query<GetServiceRequestListingQuery, GetServiceRequestListingQueryVariables> {
    document = GetServiceRequestListingDocument;
    client = 'cloud';
  }
export const GetRequestLogByRequestIdDocument = gql`
    query getRequestLogByRequestId($requestId: String!, $tenantView: Boolean!) {
  serviceRequestById(RequestId: $requestId) {
    ID
    unitNo
    requestNo
    areaDescription: publicAreaId
    requestTypeData {
      name
    }
    publicAreaData {
      name
    }
    createdTs
    requestStatus
    requestLogs(IsShow: $tenantView) {
      ID
      logTenant
      createdTs
      requestStatus
      requestActivity(TenantView: $tenantView) {
        assignTo {
          name
        }
        ID
        numberOfAttachment
        requestFollowUp {
          ID
          numberOfAttachment
        }
        requestQuotation {
          ID
          numberOfAttachment
        }
        requestEstimation {
          ID
          numberOfAttachment
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestLogByRequestIdGQL extends Apollo.Query<GetRequestLogByRequestIdQuery, GetRequestLogByRequestIdQueryVariables> {
    document = GetRequestLogByRequestIdDocument;
    client = 'cloud';
  }
export const GetRequestDetailQuotationByRequestIdDocument = gql`
    query GetRequestDetailQuotationByRequestId($requestId: String!) {
  serviceRequestById(RequestId: $requestId) {
    ID
    unitNo
    requestNo
    areaDescription: publicAreaId
    requestTypeData {
      name
    }
    publicAreaData {
      name
    }
    createdTs
    requestStatus
    requestActivities {
      ID
      requestQuotation {
        ID
        operatorContactNo
        operatorEmail
        operatorName
        isProceed
        attachment {
          ID
          fileName
          resourceUrl
          fileSize
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestDetailQuotationByRequestIdGQL extends Apollo.Query<GetRequestDetailQuotationByRequestIdQuery, GetRequestDetailQuotationByRequestIdQueryVariables> {
    document = GetRequestDetailQuotationByRequestIdDocument;
    client = 'cloud';
  }
export const GetQuotationByRequestIdDocument = gql`
    query GetQuotationByRequestId($requestId: String!) {
  serviceRequestById(RequestId: $requestId) {
    ID
    requestActivities {
      ID
      requestQuotation {
        ID
        operatorContactNo
        operatorEmail
        operatorName
        attachment {
          ID
          fileName
          resourceUrl
          fileSize
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQuotationByRequestIdGQL extends Apollo.Query<GetQuotationByRequestIdQuery, GetQuotationByRequestIdQueryVariables> {
    document = GetQuotationByRequestIdDocument;
    client = 'cloud';
  }
export const GetServiceDetailAttachmentByRequestIdDocument = gql`
    query GetServiceDetailAttachmentByRequestId($requestId: String!) {
  serviceRequestById(RequestId: $requestId) {
    ID
    serviceDetails {
      ID
      message
      attachment {
        ID
        mediaType
        fileName
        resourceUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceDetailAttachmentByRequestIdGQL extends Apollo.Query<GetServiceDetailAttachmentByRequestIdQuery, GetServiceDetailAttachmentByRequestIdQueryVariables> {
    document = GetServiceDetailAttachmentByRequestIdDocument;
    client = 'cloud';
  }
export const GetRequestActivityByIdDocument = gql`
    query GetRequestActivityById($ActivityId: String!) {
  requestActivityById(ActivityId: $ActivityId) {
    ID
    requestStatus
    remark
    createdTs
    assignTo {
      ID
      name
    }
    attachment {
      ID
      fileName
      mediaType
      resourceUrl
    }
    requestFollowUp {
      ID
      activityDate
      appointDate
      attachment {
        ID
        fileName
        mediaType
        resourceUrl
      }
    }
    requestQuotation {
      ID
      isProceed
      reason
      operatorName
      operatorContactNo
      operatorEmail
      attachment {
        ID
        fileName
        mediaType
        resourceUrl
      }
    }
    requestEstimation {
      ID
      processDate
      completeDate
      durationDay
      durationHour
      attachment {
        ID
        fileName
        mediaType
        resourceUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestActivityByIdGQL extends Apollo.Query<GetRequestActivityByIdQuery, GetRequestActivityByIdQueryVariables> {
    document = GetRequestActivityByIdDocument;
    client = 'cloud';
  }
export const GetRequestActvityAttachmentDocument = gql`
    query getRequestActvityAttachment($input: AttachmentByRefIdAndRefTableInput!) {
  AttachmentByRefIdAndRefTable(input: $input) {
    ID
    mediaType
    resourceUrl
    fileName
    fileSize
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRequestActvityAttachmentGQL extends Apollo.Query<GetRequestActvityAttachmentQuery, GetRequestActvityAttachmentQueryVariables> {
    document = GetRequestActvityAttachmentDocument;
    client = 'cloud';
  }
export const GetFilteredServiceRequestListingDocument = gql`
    query getFilteredServiceRequestListing($RequestStatus: [String!]!, $OrderBy: String!) {
  filteredServiceRequestByDebtorId(
    RequestStatus: $RequestStatus
    OrderBy: $OrderBy
  ) {
    ID
    requestNo
    requestTitle
    createdTs
    requestStatus
    lDebtorId
    unitNo
    areaDescription: publicAreaId
    requestTypeData {
      name
    }
    publicAreaData {
      name
    }
    areaDescription: publicAreaId
    serviceRequestQuotationCount {
      ID
      quotationCount
    }
    serviceDetailsMediaCount {
      ID
      textMediaCount
      audioMediaCount
      imageMediaCount
      videoMediaCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFilteredServiceRequestListingGQL extends Apollo.Query<GetFilteredServiceRequestListingQuery, GetFilteredServiceRequestListingQueryVariables> {
    document = GetFilteredServiceRequestListingDocument;
    client = 'cloud';
  }
export const ProceedRequestQuotationDocument = gql`
    mutation ProceedRequestQuotation($RequestQuotationId: String!, $Reason: String) {
  ProceedRequestQuotation(
    RequestQuotationId: $RequestQuotationId
    Reason: $Reason
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProceedRequestQuotationGQL extends Apollo.Mutation<ProceedRequestQuotationMutation, ProceedRequestQuotationMutationVariables> {
    document = ProceedRequestQuotationDocument;
    client = 'cloud';
  }
export const CancelServiceRequestDocument = gql`
    mutation CancelServiceRequest($input: CancelServiceRequestModel!) {
  CancelServiceRequest(CancelServiceRequestModel: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelServiceRequestGQL extends Apollo.Mutation<CancelServiceRequestMutation, CancelServiceRequestMutationVariables> {
    document = CancelServiceRequestDocument;
    client = 'cloud';
  }
export const InsertDownloadLogDocument = gql`
    mutation insertDownloadLog($fileSize: Float!, $fileName: String!, $attachmentId: String, $path: String!) {
  insertDownloadLog(
    attachmentId: $attachmentId
    path: $path
    fileSize: $fileSize
    fileName: $fileName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertDownloadLogGQL extends Apollo.Mutation<InsertDownloadLogMutation, InsertDownloadLogMutationVariables> {
    document = InsertDownloadLogDocument;
    client = 'cloud';
  }
export const GetCloudRequestTypeDocument = gql`
    query getCloudRequestType {
  getCloudRequestType {
    name
    seqNo
    ID
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCloudRequestTypeGQL extends Apollo.Query<GetCloudRequestTypeQuery, GetCloudRequestTypeQueryVariables> {
    document = GetCloudRequestTypeDocument;
    client = 'cloud';
  }
export const GetCloudPublicAreaDocument = gql`
    query getCloudPublicArea {
  getCloudPublicArea {
    name
    seqNo
    ID
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCloudPublicAreaGQL extends Apollo.Query<GetCloudPublicAreaQuery, GetCloudPublicAreaQueryVariables> {
    document = GetCloudPublicAreaDocument;
    client = 'cloud';
  }
export const GetUserListDocument = gql`
    query getUserList {
  getTenantUsersByAccountDebtor {
    ID
    name
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserListGQL extends Apollo.Query<GetUserListQuery, GetUserListQueryVariables> {
    document = GetUserListDocument;
    client = 'cloud';
  }
export const GetRoleListDocument = gql`
    query getRoleList {
  getRoleByAccountId {
    ID
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoleListGQL extends Apollo.Query<GetRoleListQuery, GetRoleListQueryVariables> {
    document = GetRoleListDocument;
    client = 'cloud';
  }
export const GetUserDetailDocument = gql`
    query getUserDetail($userId: String!) {
  getUserById(userId: $userId) {
    ID
    email
    name
    contactNo
    confirmed
  }
  getUserRoleByUserId(userId: $userId) {
    ID
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserDetailGQL extends Apollo.Query<GetUserDetailQuery, GetUserDetailQueryVariables> {
    document = GetUserDetailDocument;
    client = 'cloud';
  }
export const EditUserAndRoleDocument = gql`
    mutation editUserAndRole($input: EditTenantUserAndRoleInput!) {
  editUserAndRole(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditUserAndRoleGQL extends Apollo.Mutation<EditUserAndRoleMutation, EditUserAndRoleMutationVariables> {
    document = EditUserAndRoleDocument;
    client = 'cloud';
  }
export const GetUserProfileDocument = gql`
    query getUserProfile {
  getUserProfile {
    name
    email
    contactNo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserProfileGQL extends Apollo.Query<GetUserProfileQuery, GetUserProfileQueryVariables> {
    document = GetUserProfileDocument;
    client = 'cloud';
  }
export const EditUserProfileDocument = gql`
    mutation editUserProfile($input: UpdateUserProfileInput!) {
  editUserProfileContact(input: $input) {
    name
    email
    contactNo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditUserProfileGQL extends Apollo.Mutation<EditUserProfileMutation, EditUserProfileMutationVariables> {
    document = EditUserProfileDocument;
    client = 'cloud';
  }